import {
  formatProjectTypeLabel,
  getProjectTypeClass,
} from '../../utils/formatProjectTypeLabel';
import './ProjectTypeBadge.css';

const ProjectTypeBadge = ({ type, className = '', style, as: Tag = 'span' }) => {
  const classes = [
    'project-type-badge',
    getProjectTypeClass(type),
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} style={style} title={formatProjectTypeLabel(type)}>
      {formatProjectTypeLabel(type)}
    </Tag>
  );
};

export default ProjectTypeBadge;
